exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input::-webkit-input-placeholder {\r\n    color: red;\r\n}\r\n\r\ninput:-moz-placeholder {\r\n    /* Firefox 18- */\r\n    color: red;\r\n}\r\n\r\ninput::-moz-placeholder {\r\n    /* Firefox 19+ */\r\n    color: red;\r\n}\r\n\r\ninput:-ms-input-placeholder {\r\n    color: red;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/locator/locator.component.css
// module id = ../../../../../src/widgets/locator/locator.component.css
// module chunks = main